import { useState, useEffect } from 'react';
import {
  Box,
  TextField,
  Button,
  Typography,
  Grid,
  Paper,
  Snackbar,
  Alert,
} from '@mui/material';
import config from '../../config.json';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Upload_Icon from "../../images/vehicle/Upload_icon.svg";
import { useUser } from '../../pages/login/UserContextPersistent';
export default function RegisterMoreDetails() {
  const navigate = useNavigate();
  const { state } = useUser(); // Access user state from context
  const [orgId, setOrgId] = useState('');
  const [orgData, setOrgData] = useState({});
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(true);
  const [notification, setNotification] = useState({
    open: false,
    message: '',
    severity: 'success',
  });

  const inputStyle = {
    width: '100%',
    height: 55,
    '& .MuiOutlinedInput-root': {
      borderRadius: '16px',
      borderWidth: '2px',
      '& fieldset': {
        border: '2px solid #183059',
      },
      '&:hover fieldset': {
        border: '2px solid #183059',
      },
      '&.Mui-focused fieldset': {
        border: '2px solid #183059',
      },
    },
    '& .MuiInputBase-input': {
      padding: '16px 24px',
      background: '#FFFFFF',
    },
    gap: '12px',
  };

  useEffect(() => {
    const fetchData = async () => {
      const userState = localStorage.getItem('userState');

      if (userState) {
        const parsedUserState = JSON.parse(userState);

        if (parsedUserState?.user?.organizationId) {
          setOrgId(parsedUserState.user.organizationId);

          try {
            setLoading(true);
            const response = await axios.get(`${config.baseURL}/organization/${parsedUserState.user.organizationId}`);
            console.log('Data:', response.data.organization);
            setOrgData(response.data.organization);
            setFormData(response.data.organization);
          } catch (error) {
            console.error('Error fetching organization data:', error);
            setNotification({
              open: true,
              message: 'Failed to load organization data',
              severity: 'error',
            });
          } finally {
            setLoading(false);
          }
        }
      }
    };

    fetchData();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const userState = localStorage.getItem('userState');
      const parsedUserState = JSON.parse(userState);

      const response = await axios.put(
        `${config.baseURL}/organization/${parsedUserState.user.organizationId}`,
        formData,
        {
          headers: { "Content-Type": "application/json" },
          credentials: "include",
        }
      );

      if (response.data.organization) {
        setOrgData(response.data.organization);
        setNotification({
          open: true,
          message: 'Organization updated successfully',
          severity: 'success',
        });
        // Optionally navigate after a delay
        setTimeout(() => navigate("/registerfeature"), 2000);
      }
    } catch (error) {
      console.error('Error updating organization:', error);
      setNotification({
        open: true,
        message: 'Failed to update organization',
        severity: 'error',
      });
    }
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      console.log("Image uploaded:", file.name);
      // Add logic to upload the image to your API if needed
    }
  };

  const handleCancel = () => {
    setFormData(orgData);
  };

  const handlenavigate = () => {
    navigate("/registerfeature");
  };

  const handleCloseNotification = () => {
    setNotification({ ...notification, open: false });
  };

  if (loading) {
    return <Typography>Loading...</Typography>;
  }

  return (
    <Box sx={{ bgcolor: "#F2F2F3", padding: "40px 40px" }}>
      <Paper sx={{ borderRadius: '8px', overflow: 'hidden', padding: "20px", border: "1px solid #A5DCF3", boxShadow: "-2px 2px 5px 0px #00000040" }}>
        <Box sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
          gap: "8px",
          padding: "20px 20px"
        }}>
          <Typography sx={{
            fontFamily: 'Roboto',
            fontWeight: 600,
            fontSize: '36px',
            lineHeight: '100%',
            letterSpacing: '0%',
            color: '#183059'
          }}>
            Complete Your Organization Profile
          </Typography>
          <Typography sx={{
            fontFamily: 'Roboto',
            fontWeight: 400,
            fontSize: '20px',
            lineHeight: '140%',
            letterSpacing: '0%',
            textTransform: 'capitalize',
            color: '#1F242E'
          }}>
            Tell Us About Your Organization To Customize RouteEye For You.
          </Typography>
        </Box>
        <Box component="form" noValidate onSubmit={handleSubmit} sx={{ mt: 1 }}>
          {/* Organization Details Section */}
          <Box>
            <Box sx={{
              width: '100%',
              height: 52,
              gap: 16,
              pt: 1.5,
              px: 3,
              pb: 1.5,
              borderRadius: "8px",
              bgcolor: '#647490',
              boxShadow: '-2px 2px 5px 0px #00000040',
              color: 'white',
              fontSize: '1.2rem',
              fontWeight: 'bold'
            }}>
              Organization Details
            </Box>
            <Box sx={{ p: 3 }}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={4}>
                  <Typography variant="subtitle2" sx={{ mb: 1 }}>Organization Name *</Typography>
                  <TextField
                    required
                    fullWidth
                    value={formData.name || ''}
                    onChange={handleInputChange}
                    id="name"
                    placeholder="Enter Organization Name"
                    name="name"
                    variant="outlined"
                    InputLabelProps={{ shrink: true }}
                    sx={inputStyle}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <Typography variant="subtitle2" sx={{ mb: 1 }}>Website</Typography>
                  <TextField
                    fullWidth
                    id="domain"
                    value={formData.domain || ''}
                    onChange={handleInputChange}
                    placeholder="Enter Website"
                    name="domain"
                    variant="outlined"
                    InputLabelProps={{ shrink: true }}
                    sx={inputStyle}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <Typography variant="subtitle2" sx={{ mb: 1 }}>Country *</Typography>
                  <TextField
                    required
                    fullWidth
                    value={formData.country || ''}
                    onChange={handleInputChange}
                    id="country"
                    placeholder="Enter Country"
                    name="country"
                    variant="outlined"
                    InputLabelProps={{ shrink: true }}
                    sx={inputStyle}
                  />
                </Grid>
                <Grid item xs={12} md={8}>
                  <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                      <Typography variant="subtitle2" sx={{ mb: 1 }}>City</Typography>
                      <TextField
                        fullWidth
                        value={formData.city || ''}
                        onChange={handleInputChange}
                        id="city"
                        placeholder="Enter City"
                        name="city"
                        variant="outlined"
                        InputLabelProps={{ shrink: true }}
                        sx={inputStyle}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Typography variant="subtitle2" sx={{ mb: 1 }}>State *</Typography>
                      <TextField
                        required
                        fullWidth
                        value={formData.state || ''}
                        onChange={handleInputChange}
                        id="state"
                        placeholder="Enter State"
                        name="state"
                        variant="outlined"
                        InputLabelProps={{ shrink: true }}
                        sx={inputStyle}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Typography variant="subtitle2" sx={{ mb: 1 }}>Address *</Typography>
                      <TextField
                        required
                        fullWidth
                        id="address"
                        value={formData.address || ''}
                        onChange={handleInputChange}
                        placeholder="Enter Address Line 1"
                        name="address"
                        variant="outlined"
                        InputLabelProps={{ shrink: true }}
                        sx={inputStyle}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Typography variant="subtitle2" sx={{ mb: 1 }}>Pincode *</Typography>
                      <TextField
                        required
                        fullWidth
                        id="pincode"
                        value={formData.pincode || ''}
                        onChange={handleInputChange}
                        placeholder="Enter Pincode"
                        name="pincode"
                        variant="outlined"
                        InputLabelProps={{ shrink: true }}
                        sx={inputStyle}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12} md={4} sx={{ display: 'flex', flexDirection: 'column' }}>
                  <Box sx={{
                    border: '2px dashed #ccc',
                    borderRadius: '8px',
                    p: 2,
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    position: 'relative'
                  }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 1 }}>
                      <img src={Upload_Icon} alt="Upload" style={{ width: 40, height: 40 }} />
                    </Box>
                    <Box sx={{ textAlign: 'center' }}>
                      <Typography variant="body1" sx={{ color: '#1F242E', fontFamily: 'Roboto', fontWeight: 600, fontSize: '16px', lineHeight: '100%', mb: 1 }}>
                        Organization Icon
                      </Typography>
                      <Typography variant="body2" sx={{ color: '#666' }}>Click to upload or drag and drop</Typography>
                      <Typography variant="body2" sx={{ color: '#666', fontSize: '12px' }}>PNG, JPG, GIF up to 10MB</Typography>
                    </Box>
                    <input
                      type="file"
                      accept="image/*"
                      onChange={handleImageUpload}
                      style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', opacity: 0, cursor: 'pointer' }}
                    />
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Box>

          {/* Contact Details Section */}
          <Box>
            <Box sx={{
              width: '100%',
              height: 52,
              gap: 16,
              pt: 1.5,
              px: 3,
              pb: 1.5,
              borderRadius: "8px",
              bgcolor: '#647490',
              boxShadow: '-2px 2px 5px 0px #00000040',
              color: 'white',
              fontSize: '1.2rem',
              fontWeight: 'bold'
            }}>
              Contact Details
            </Box>
            <Box sx={{ p: 3 }}>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={4}>
                  <Typography variant="subtitle2" sx={{ mb: 1 }}>Full Name *</Typography>
                  <TextField
                    required
                    fullWidth
                    id="contactName"
                    value={formData.contactName || ''}
                    onChange={handleInputChange}
                    placeholder="Enter Full Name"
                    name="contactName"
                    variant="outlined"
                    InputLabelProps={{ shrink: true }}
                    sx={inputStyle}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Typography variant="subtitle2" sx={{ mb: 1 }}>Email *</Typography>
                  <TextField
                    required
                    fullWidth
                    id="contactEmail"
                    value={formData.contactEmail || ''}
                    onChange={handleInputChange}
                    placeholder="Enter Email"
                    name="contactEmail"
                    type="email"
                    variant="outlined"
                    InputLabelProps={{ shrink: true }}
                    sx={inputStyle}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Typography variant="subtitle2" sx={{ mb: 1 }}>Phone Number *</Typography>
                  <TextField
                    required
                    fullWidth
                    id="contactPhone"
                    value={formData.contactPhone || ''}
                    onChange={handleInputChange}
                    placeholder="Enter Phone Number"
                    name="contactPhone"
                    variant="outlined"
                    InputLabelProps={{ shrink: true }}
                    sx={inputStyle}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Typography variant="subtitle2" sx={{ mb: 1 }}>Employee ID *</Typography>
                  <TextField
                    required
                    fullWidth
                    id="contactEmployeeId"
                    value={formData.contactEmployeeId || ''}
                    onChange={handleInputChange}
                    placeholder="Enter Employee ID"
                    name="contactEmployeeId"
                    variant="outlined"
                    InputLabelProps={{ shrink: true }}
                    sx={inputStyle}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Typography variant="subtitle2" sx={{ mb: 1 }}>Department *</Typography>
                  <TextField
                    required
                    fullWidth
                    id="contactDepartment"
                    value={formData.contactDepartment || ''}
                    onChange={handleInputChange}
                    placeholder="Enter Department"
                    name="contactDepartment"
                    variant="outlined"
                    InputLabelProps={{ shrink: true }}
                    sx={inputStyle}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Typography variant="subtitle2" sx={{ mb: 1 }}>Designation *</Typography>
                  <TextField
                    required
                    fullWidth
                    id="contactDesignation"
                    value={formData.contactDesignation || ''}
                    onChange={handleInputChange}
                    placeholder="Enter Designation"
                    name="contactDesignation"
                    variant="outlined"
                    InputLabelProps={{ shrink: true }}
                    sx={inputStyle}
                  />
                </Grid>
              </Grid>
            </Box>
          </Box>

          {/* Transport In-Charge Details Section */}
          <Box>
            <Box sx={{
              width: '100%',
              height: 52,
              gap: 16,
              pt: 1.5,
              px: 3,
              pb: 1.5,
              borderRadius: "8px",
              bgcolor: '#647490',
              boxShadow: '-2px 2px 5px 0px #00000040',
              color: 'white',
              fontSize: '1.2rem',
              fontWeight: 'bold'
            }}>
              Transport In-Charge Details (Optional)
            </Box>
            <Box sx={{ p: 3 }}>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={4}>
                  <Typography variant="subtitle2" sx={{ mb: 1 }}>Full Name</Typography>
                  <TextField
                    fullWidth
                    id="transportFullName"
                    value={formData.transportFullName || ''}
                    onChange={handleInputChange}
                    placeholder="Enter Full Name"
                    name="transportFullName"
                    variant="outlined"
                    InputLabelProps={{ shrink: true }}
                    sx={inputStyle}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Typography variant="subtitle2" sx={{ mb: 1 }}>Email</Typography>
                  <TextField
                    fullWidth
                    id="transportEmail"
                    value={formData.transportEmail || ''}
                    onChange={handleInputChange}
                    placeholder="Enter Email"
                    name="transportEmail"
                    type="email"
                    variant="outlined"
                    InputLabelProps={{ shrink: true }}
                    sx={inputStyle}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Typography variant="subtitle2" sx={{ mb: 1 }}>Phone Number</Typography>
                  <TextField
                    fullWidth
                    id="transportPhoneNumber"
                    value={formData.transportPhoneNumber || ''}
                    onChange={handleInputChange}
                    placeholder="Enter Phone Number"
                    name="transportPhoneNumber"
                    variant="outlined"
                    InputLabelProps={{ shrink: true }}
                    sx={inputStyle}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Typography variant="subtitle2" sx={{ mb: 1 }}>Employee ID</Typography>
                  <TextField
                    fullWidth
                    id="transportEmployeeId"
                    value={formData.transportEmployeeId || ''}
                    onChange={handleInputChange}
                    placeholder="Enter Employee ID"
                    name="transportEmployeeId"
                    variant="outlined"
                    InputLabelProps={{ shrink: true }}
                    sx={inputStyle}
                  />
                </Grid>
              </Grid>
            </Box>
          </Box>

          <Box sx={{
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginTop: 2
          }}>
            <Box sx={{ display: 'flex', gap: 2 }}>
              <Button
                variant="outlined"
                onClick={handleCancel}
                sx={{
                  width: 122,
                  height: 55,
                  borderRadius: '8px',
                  borderWidth: '1px',
                  paddingTop: '16px',
                  paddingRight: '24px',
                  paddingBottom: '16px',
                  paddingLeft: '24px',
                  background: '#F2F2F3',
                  border: '1px solid #414958',
                  color: "#1F242E",
                  fontFamily: "Roboto",
                  fontWeight: "500",
                  fontSize: "20px",
                  textTransform: "none"
                }}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                type="submit" // Changed to submit to trigger form submission
                sx={{
                  width: 125,
                  height: 55,
                  borderRadius: '8px',
                  borderWidth: '1px',
                  paddingTop: '16px',
                  paddingRight: '24px',
                  paddingBottom: '16px',
                  paddingLeft: '24px',
                  background: '#F9E719',
                  border: '1px solid #414958',
                  color: "#1F242E",
                  fontFamily: "Roboto",
                  fontWeight: "500",
                  fontSize: "20px",
                  textTransform: "none",
                  "&:hover": { background: "#F9E719" }
                }}
              >
                Save
              </Button>
            </Box>
            <Button
              variant="contained"
              onClick={handlenavigate}
              sx={{
                height: 55,
                borderRadius: '8px',
                borderWidth: '1px',
                paddingTop: '16px',
                paddingRight: '24px',
                paddingBottom: '16px',
                paddingLeft: '24px',
                background: '#F9E719',
                border: '1px solid #414958',
                color: "#1F242E",
                fontFamily: "Roboto",
                fontWeight: "500",
                fontSize: "20px",
                textTransform: "none",
                "&:hover": { background: "#F9E719" }
              }}
            >
              Share Your Requirement
            </Button>
          </Box>
        </Box>
      </Paper>
      {/* <Snackbar
        open={notification.open}
        autoHideDuration={3000}
        onClose={handleCloseNotification}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={handleCloseNotification} severity={notification.severity} sx={{ width: '100%' }}>
          {notification.message}
        </Alert>
      </Snackbar> */}
      <Box sx={{ height: 2 }}></Box>
    </Box>
  );
}